import React, { useState, useEffect } from "react";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
} from "reactstrap";
import { Add, Cancel } from "../../../Utils/Constants";
import { Btn } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  addCategory,
  updateCategory,
} from "../../../ReduxToolkit/Reducers/ProductsReducer";

export default function NewCategoryModal({ category, setCategory }) {
  const [tableform, setTableform] = useState({
    name: "",
    points_per_dollar: 0,
    points_per_item: 0,
    point_mode: "per_dollar", // default
    discount_enable: false,
  });

  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  useEffect(() => {
    if (category?.term_id) {
      setTableform({
        term_id: category.term_id,
        name: category.name || "",
        points_per_dollar: category.points_per_dollar ?? 0,
        points_per_item: category.points_per_item ?? 0,
        point_mode: category.point_mode ?? "per_dollar",
        discount_enable:
          category.discount_enable === true ||
          category.discount_enable === "true",
      });
      setModal(true);
    }
  }, [category]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTableform((prevForm) => ({
      ...prevForm,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSaveCategory = async () => {
    try {
      const result = category?.term_id
        ? await dispatch(updateCategory(tableform))
        : await dispatch(addCategory(tableform));

      if (result.payload.success) {
        toast.success(
          `Category ${category?.term_id ? "Updated" : "Saved"} Successfully`
        );
      }
    } catch (error) {
      console.log(error);
      toast.error("Error saving category");
    }

    setCategory({});
    setTableform({
      name: "",
      points_per_dollar: 0,
      points_per_item: 0,
      point_mode: "per_dollar",
      discount_enable: false,
    });
    toggle();
  };

  return (
    <Col xs={12}>
      <div>
        <Btn className="btn btn-primary" color="primary" onClick={toggle}>
          <i className="fa fa-plus me-2"></i> Add New Category
        </Btn>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Add New Category</ModalHeader>
        <ModalBody className="custom-input">
          <div className="create-category">
            <div className="mb-3">
              <Label>
                Category Name <span className="txt-danger">*</span>
              </Label>
              <Input
                type="text"
                required
                value={tableform.name}
                name="name"
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <Label>Point Earning Mode</Label>
              <div className="d-flex gap-3">
                <FormGroup check>
                  <Input
                    type="radio"
                    name="point_mode"
                    value="per_dollar"
                    checked={tableform.point_mode === "per_dollar"}
                    onChange={handleChange}
                  />{" "}
                  <Label check>Points Per Dollar</Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="radio"
                    name="point_mode"
                    value="per_item"
                    checked={tableform.point_mode === "per_item"}
                    onChange={handleChange}
                  />{" "}
                  <Label check>Points Per Item</Label>
                </FormGroup>
              </div>
            </div>

            {tableform.point_mode === "per_dollar" && (
              <div className="mb-3">
                <Label>Points Per Dollar</Label>
                <Input
                  type="number"
                  name="points_per_dollar"
                  value={tableform.points_per_dollar}
                  onChange={handleChange}
                  min="0"
                  step="0.01"
                />
              </div>
            )}

            {tableform.point_mode === "per_item" && (
              <div className="mb-3">
                <Label>Points Per Item</Label>
                <Input
                  type="number"
                  name="points_per_item"
                  value={tableform.points_per_item}
                  onChange={handleChange}
                  min="0"
                  step="1"
                />
              </div>
            )}

            <div className="form-check form-switch mb-3">
              <Input
                className="form-check-input"
                type="checkbox"
                name="discount_enable"
                id="discountEnableSwitch"
                checked={tableform.discount_enable}
                onChange={handleChange}
              />
              <Label
                className="form-check-label"
                htmlFor="discountEnableSwitch"
              >
                Allow Discount
              </Label>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Btn
            color="light"
            onClick={() => {
              toggle();
              setCategory({});
            }}
          >
            {Cancel}
          </Btn>
          <Btn color="primary" onClick={handleSaveCategory}>
            {Add}
          </Btn>
        </ModalFooter>
      </Modal>
    </Col>
  );
}
